import './RMA.scss';
import {PageManager} from 'genesis-packages/core';
import 'extensions/rma';
import 'extensions/rma/components/x-rma-invoice-lookup-form';

export default class RMA extends PageManager {

	constructor (pageContext) {
		super(pageContext);
	}

}
